import { useAuth } from "@/context/AuthContext";
import { useShop } from "@/context/ShopContext";
import { Link } from "react-router-dom";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { user, loading } = useAuth();
  const { wishlist } = useShop();

  if (!loading && !user?.user_id) {
    return (
      <div className="mx-auto max-w-lg px-4 py-24 text-center">
        <h1 className="text-2xl font-extrabold text-midnight">Sign in to view your wishlist</h1>
        <Link to="/login" className="mt-6 inline-block rounded-full bg-midnight px-8 py-3 font-bold text-white">Login</Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 py-10">
      <h1 className="text-3xl font-extrabold text-midnight mb-8">My Wishlist <span className="text-lg text-muted-foreground">({wishlist.length})</span></h1>
      {wishlist.length === 0 ? (
        <div className="rounded-3xl border border-dashed border-border py-24 text-center">
          <p className="text-lg font-bold text-midnight">Your wishlist is empty</p>
          <Link to="/shop" className="mt-4 inline-block rounded-full bg-midnight px-8 py-3 font-bold text-white">Browse Products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5" data-testid="wishlist-grid">
          {wishlist.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
